<template>
    <div class="vm-feed-timing flex-box flex-align-item-center flex-justify-content-space-between" :class="browser_size" @click="open_date">
        <div class="flex-box flex-align-item-center fs14 black-8">
            <i class="afd afd-clock mr8"></i>
            <span>{{$t('c.FeedTiming.text1')}}</span>
        </div>
        <date-picker type="datetime" format="YYYY-MM-DD HH:mm" valueType="timestamp" :clearable="false" :open="is_date_open" @confirm="close_date" :confirm="true" placeholder="0000-00-00 00:00" :editable="false" v-model="timing_pre">
            <i slot="icon-calendar" class="afd afd-x fs12 black" style="top:-1px;position: relative;" @click="close_timing"></i>
        </date-picker>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'; // https://github.com/mengxiong10/vue2-datepicker/blob/master/README.zh-CN.md
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/zh-cn';
import {
    POST_POST_LIKE,
    POST_POST_UNLIKE,
    POST_COMMENT_LIKE,
    POST_COMMENT_UNLIKE,
} from '@/api/config'
import { mapState } from 'vuex';

export default {
    name: 'like',
    props: {
        timing: {
            default(){
                return 0
            }
        }
    },
    model: {
        prop: 'timing',
        event: 'change'
    },
    watch:{
        timing_pre(){
            this.$emit("change", this.timing_pre);
        }
    },
    data() {
        let t = this.timing ?  this.timing : new Date().getTime() + 1000 * 60 * 10
        this.$emit("change", t);
        return {
            timing_pre:t,
            is_show_more:false,
            is_date_open:true,
        };
    },
    components:{
        DatePicker
    },
    computed:{
        ...mapState('app', ['session_user', 'browser_size']),
        post_data(){
            let data = {}
            if(this.data.post_id){
                data.post_id =  this.data.post_id
            }
            if(this.data.comment_id){
                data.comment_id =  this.data.comment_id
            }
            return data
        },
        api(){
            let api = {}
            if(this.data.post_id){
                api = this.data.has_like ? POST_POST_UNLIKE : POST_POST_LIKE
            }
            if(this.data.comment_id){
                api = this.data.has_like ? POST_COMMENT_UNLIKE : POST_COMMENT_LIKE
            }
            return api
        },
    },
    destroyed(){
        this.$store.dispatch('app/set:is_show_timing', false);
    },
    mounted() {
    },
    methods: {
        // change(v) {
        //     this.$emit("change", this.timing_pre);
        // },
        open_date(){
            this.is_date_open = true;
        },
        close_date(){
            this.is_date_open = false;
        },
        close_timing(){
            this.$emit("change", 0);
            this.$store.dispatch('app/set:is_show_timing', false);
        },
        async like_action(){
            if (this.$http.is_run(this.api)) {
                return false
            }
            let data = await this.$http.$axios(this.api, this.post_data)

            if(data.ec != 200){
                this.$notify({
                    title: data.em,
                    group: 'error',
                })
                return false
            }
            if(this.data.has_like){
                this.$emit('unlike_success', this.post_data)
            }
            else{
                this.$emit('like_success', this.post_data)
            }
        },
    }
};
</script>
<style lang="stylus" scoped>
.vm-feed-timing{
    background:$white;
    box-sizing:border-box;
    width:100%;
    padding-bottom:16px;
    cursor:pointer;
    .afd-clock{
        width:14px;
        height:14px;
        position:relative;
        top:2px;
    }
    & /deep/{
        .mx-input{
            padding: 0;
            border: 0;
            background: none;
            box-shadow: none;
            height: auto;
            color:$black-8;
        }
        .mx-datepicker{
            width:150px;
            cursor:pointer;
        }
    }
    &.small{
        background:$white-bg;
        width:100vw;
        margin:16px 0 0 -16px;
        padding:16px;
    }
}
</style>